export default "/WebApp/dist/assets/svg/ui-grid.svg";